export default __webpack_public_path__ + "static/media/KlipVidOne.30d755bc.png";